// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"149":"accountshare","298":"wishes","337":"publicgroup","593":"addfriendaccount","756":"group","813":"groupshare"}[chunkId] + "." + {"149":"96ceda02","298":"b92de769","337":"e1c7156b","593":"d9899198","756":"a90d6b2f","813":"96ceda02"}[chunkId] + ".css";
};